var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasStationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 9.33L20.84 8.33C20.47 8.15 20.01 8.29 19.83 8.66C19.64 9.04 19.79 9.49 20.16 9.67L21.75 10.46V15.25L18 15.26V5C18 3 16.66 2 15 2H7C5.34 2 4 3 4 5V21.25H2.5C2.09 21.25 1.75 21.59 1.75 22C1.75 22.41 2.09 22.75 2.5 22.75H19.5C19.91 22.75 20.25 22.41 20.25 22C20.25 21.59 19.91 21.25 19.5 21.25H18V16.76L22.5 16.75C22.92 16.75 23.25 16.41 23.25 16V10C23.25 9.72 23.09 9.46 22.84 9.33ZM6.5 6.89C6.5 5.5 7.35 5 8.39 5H13.62C14.65 5 15.5 5.5 15.5 6.89V8.12C15.5 9.5 14.65 10 13.61 10H8.39C7.35 10 6.5 9.5 6.5 8.11V6.89ZM7 12.25H10C10.41 12.25 10.75 12.59 10.75 13C10.75 13.41 10.41 13.75 10 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25Z",
    fill: "url(#paint0_linear_1722_53196)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1722_53196",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStationActive);
export default __webpack_public_path__ + "static/media/gas-station-active.09f0e08b5b16a09b9fc182aeed56d021.svg";
export { ForwardRef as ReactComponent };